import "./App.css";

import { BrowserRouter, Route, Routes } from "react-router";

import { AboutUs } from "./AboutUs/AboutUs";
import { Footer } from "./Footer/Footer";
import MainPage from "./MainPage/MainPage";
import NavBar from "./NavBar/Navbar";
import { Portfolio } from "./Portfolio/Portfolio";
import { Services } from "./Services/Services";

function App() {
  return (
    <div>
      <BrowserRouter>
        <NavBar></NavBar>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
